// extracted by mini-css-extract-plugin
export default {"image":"image-load_image__lEOk4"};